import { makeStyles } from "@material-ui/core";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

const useStyles = makeStyles((theme) => ({
    cardStyle: {
        backgroundColor: '#343434',
        border: '1px solid #505050CC',
        paddingLeft: 12,
        paddingTop: 8,
        paddingBottom: 20,
        paddingRight: 8,
        marginRight: 40,
        marginLeft: 20,
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        alignItems: 'flex-start',
        marginTop: 24
    },
    leftCardStyle: {
        display: 'flex',
        alignItems: 'center'
    },
    basicInfoStyle: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%'
    },
    basicInfoTitleStyle: {
        width: '100%',
        color: '#FBFBFB',
        fontSize: 20,
        fontWeight: 'bold',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    basicInfoLeftStyle: {
        display: 'flex',
        flexDirection: 'column',
        color: '#FBFBFB99',
        opacity: 1,
        fontSize: 18,
        marginRight: 18
    },
    basicInfoRightStyle: {
        display: 'flex',
        flexDirection: 'column',
        opacity: 1,
        fontSize: 18,
        color: '#FBFBFB'
    },
    lineStyle: {
        marginTop: 14
    },
    rightCardStyle: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        paddingRight: 52,
    },
    storageInfoStyle: {
        color: '#FBFBFB',
        fontSize: 60
    },
    storageTextStyle: {
        color: '#FBFBFB99',
        fontSize: 18,
        marginTop: 8
    }
}));

function ParcelList(props) {
    const classes = useStyles();
    const { t } = useTranslation('selfPickup');

    const [list, setList] = useState([]);

    useEffect(() => {
        if (props.type === 'scan') {
            let listClone = [];
            props.list.forEach((order) => {
                const filter = (ele) => ele.orders.tno === order.orders.tno;
                // The props.list may not be distinct, so we have to make sure there's no duplicates
                if (!listClone.some(filter)) {
                    const scanned = props.scannedList.some(filter);
                    listClone.push(
                        {
                            ...order,
                            scanned: scanned
                        }
                    );
                }
            });
            setList(listClone);
        } else {
            setList(props.list)
        }
    }, [props.list, props.type, props.scannedList])

    return (
        <>
            {
                list?.length > 0 &&
                list.map((order, index) => (
                    <div className={classes.cardStyle} key={index}>
                        <div className={classes.basicInfoTitleStyle}>
                            <div>{order.orders.tno}</div>
                            {
                                props.type === 'scan' &&
                                !order.scanned &&
                                <div className={classes.checkStyle}><CheckCircleIcon style={{ color: 'grey' }} /></div>
                            }
                            {
                                props.type === 'scan' &&
                                order.scanned &&
                                <div className={classes.checkStyle}><CheckCircleIcon style={{ color: 'green' }} /></div>
                            }
                        </div>
                        <div className={classes.basicInfoStyle}>
                            <div className={classes.leftCardStyle}>
                                <div className={classes.basicInfoLeftStyle}>
                                    <div className={classes.lineStyle}>{t('consignee')}</div>
                                    <div className={classes.lineStyle}>{t('phone')}</div>
                                    <div className={classes.lineStyle}>{t('address')}</div>
                                    <div className={classes.lineStyle}>{t('status')}</div>
                                </div>
                                <div className={classes.basicInfoRightStyle}>
                                    <div className={classes.lineStyle}>{order.orders.consignee}</div>
                                    <div className={classes.lineStyle}>{order.orders.mobile}</div>
                                    <div className={classes.lineStyle}>{order.orders.address}</div>
                                    <div className={classes.lineStyle}>{order?.path[order?.path?.length - 1]?.pathInfo}</div>
                                </div>
                            </div>
                            <div className={classes.rightCardStyle}>
                                <div className={classes.storageInfoStyle}>{order.orders.storage_info}</div>
                                <div className={classes.storageTextStyle}>{t('storage_code')}</div>
                            </div>
                        </div>
                    </div>
                ))
            }
        </>
    )
}

export default ParcelList;